import { defineMessages } from 'react-intl';

export const buttonText = defineMessages({
  printCheckButtonLabel: {
    defaultMessage: 'Print',
    description: 'print check button label'
  }
});

export const pageHeader = defineMessages({
  reviewChecks: {
    defaultMessage: 'Review Checks',
    description: 'review checks page header'
  }
});

export const labels = defineMessages({
  printChecksTable: {
    defaultMessage: 'Checks',
    description: 'Title for Print Checks table'
  },
  checkSelected: {
    defaultMessage: 'Check Selected',
    description: 'Message for number of checks selected (singular)'
  },
  checksSelected: {
    defaultMessage: 'Checks Selected',
    description: 'Message for number of checks selected (plural)'
  },
  editLabel: {
    defaultMessage: 'Edit',
    description: 'Printing checks loader dialog label'
  }
});

export const gridHeaders = defineMessages({
  vendorNo: {
    defaultMessage: 'Vendor No.',
    description: 'Grid header for vendor number'
  },
  vendorName: {
    defaultMessage: 'Vendor Name',
    description: 'Grid header for vendor name'
  },
  amount: {
    defaultMessage: 'Amount ($)',
    description: 'Grid header for invoice amount'
  }
});

export const errors = defineMessages({
  printStatusError: {
    defaultMessage: 'Accounting Setups not found',
    description: 'Accounting Status ERROR'
  },
  invalidPaymentDate: {
    defaultMessage: 'Invalid Payment Date',
    description: 'Error message for payment date datepicker'
  },
  paymentDateRequired: {
    defaultMessage: 'Payment Date is required',
    description: 'Error message for missing payment date'
  },
  cibAccountRequired: {
    defaultMessage:
      'The system failed to retrieve any Cash In Bank accounts to use for payment. If this issue persists, please contact customer support for assistance',
    description: 'Error message for retrieving Cash in Bank Accounts'
  },
  invoicesUnlocked: {
    defaultMessage: 'One or more invoices are not locked',
    description: 'Error message for unlocked invoices'
  },
  noCIBAccountSelected: {
    defaultMessage: 'No Cash In Bank account selected',
    description: 'Error message for no Cash In Bank account selected'
  },
  noChecks: {
    defaultMessage:
      'No checks selected. To continue, select the checks you would like to print.',
    description: 'Error message for no checks selected'
  },
  noChecksSelectedToCancel: {
    defaultMessage:
      'No checks selected. To continue, select the checks you would like to cancel.',
    description:
      'Error message for no checks selected selected to Cancel Payment'
  },
  paymentDateInvalid: {
    defaultMessage:
      'Permission to post in current month is denied. Please adjust the payment date and try again.',
    description: 'Error message for payment cutoff date'
  }
});

export const placeHolders = defineMessages({
  placeHolderSelect: {
    defaultMessage: 'Select',
    description: 'Place holder message for CIB dropdown'
  }
});

export const messages = defineMessages({
  bulkChecksPrinting: {
    defaultMessage:
      'The Check count is more than {maxChecks}. Only the first {maxChecks} checks will be printed.',
    description: 'Warning message for Printing bulk checks'
  },
  bulkInvoicesAuthorizing: {
    defaultMessage:
      'The Invoice count is more than {maxInvoice}. Only the first {maxInvoice} invoices will be authorized.',
    description: 'Warning message for authorizing bulk invoices'
  }
});
